<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <div class="tab-box">
          <custom-tab-box
            :tab-data="tabData"
            :selectTab="selectTab"
            @change="handleChange"
          ></custom-tab-box>
        </div>
        <div class="custom-table-box1">
          <el-table
            :data="tableData"
            :row-style="showRow"
            stripe
            :header-cell-style="tableHeaderColor"
            style="width: 100%"
          >
            <el-table-column prop="id" label="司机姓名"></el-table-column>
            <el-table-column prop="id" label="手机号码"></el-table-column>
            <el-table-column prop="id" label="所属机构"></el-table-column>
            <el-table-column prop="id" label="车牌号码"></el-table-column>
            <el-table-column prop="id" label="责任调度"></el-table-column>
            <el-table-column prop="id" label="车队长"></el-table-column>
            <el-table-column prop="id" label="上报次数"></el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableOptions.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tableOptions.pageSize"
            background
            :total="tableOptions.total"
          />
        </div>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, detailInfo, editInfo } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
import { getAllTree } from "@/views/commonApi";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
export default {
  name: "Detail",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    DialogContainer,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "全部司机排班",
        },
        {
          label: 2,
          value: "已上报司机",
        },
        {
          label: 3,
          value: "未上报司机",
        },
      ],
      isImmediatelyGetData: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "上报司机明细",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      tableData: [
        {
          id: "反馈垃圾袋",
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
      ],
      tableOptions: {
        loading: false,
        currentPage: 1,
        pageCount: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0,
      },
    };
  },
  mounted() {},
  methods: {
    init(type) {
      this.selectTab = type;
      this.dialogObj.show = true;
    },
    handleChange(val) {
      this.selectTab = val;
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {},
    tableHeaderColor() {
      return {
        background: "#F0F5FF",
        color: "#000000",
        fontFamily: "pm",
        fontSize: "0.14rem",
      };
    },
    showRow({ row, rowIndex }) {
      let styleJson = {};
      if (rowIndex % 2 === 0) {
        styleJson = {
          height: "46px",
          background: "#fff",
        };
      } else {
        styleJson = {
          height: "46px",
          background: "rgba(240,245,255,0.4)",
          border: "none",
        };
      }
      // 返回对象
      return styleJson;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  .tab-box {
    display: flex;
    justify-content: center;
    position: sticky;
    top: -0.2rem;
    z-index: 10;
    background-color: #ffffff;
    padding: 0.1rem 0;
  }
  .custom-table-box1 {
    box-sizing: border-box;
    background: #f7f8fb;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    ::v-deep .el-table__header-wrapper {
      position: relative;
    }
    ::v-deep .el-table .cell {
      line-height: 0.3rem;
    }
  }
  .pagination-box {
    position: sticky;
    bottom: -0.22rem;
    background-color: #ffffff;
    padding: 0.2rem 0;
  }
}
</style>
